"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var Model_1 = require("./Model");
var App_1 = require("./App");
var DataStore_1 = require("./data/DataStore");
var data_1 = require("./data/data");
var getParameterByName_1 = require("./lib/functions/getParameterByName");
var Bridge_1 = require("./Bridge");
var body_css_class = getParameterByName_1.getParameterByName("body_css_class");
function getJson() {
    if (window.post_json_data) {
        return window.post_json_data;
    }
    else {
        return {};
    }
}
if (body_css_class) {
    document.body.classList.add(body_css_class);
    window.isPdf = !!body_css_class.includes("pdf");
}
var dataStore = new DataStore_1.DataStore(data_1.json);
var model = new Model_1.Model(dataStore);
window.model = model;
model.form_id = window.post_form_id || getParameterByName_1.getParameterByName("form_id") || "";
model.json_data = getJson();
model.task = window.task;
model.completedUrl = window.completedUrl;
model.cancelUrl = window.cancelUrl;
model.studentData = window.studentData;
model.definedUserId = window.definedUserId;
model.token = window.token;
model.taskUserId = window.taskUserId || 0;
console.log("++++++++++++++");
console.log(JSON.stringify(window.post_json_data));
console.log(JSON.stringify(model.json_data));
console.log("++++++++++++++");
window.pdf = new Bridge_1.Bridge(model);
ReactDOM.render(React.createElement(App_1.App, { model: model }), document.getElementById("root"));
//# sourceMappingURL=data:application/json;base64,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